import {
  ModelInput, ModelNewNumericInput,
  TableIcon,
  TextInput,
} from '@equifinance/shared';
import styled from 'styled-components';
import { ActionButton } from '../../../../CasesTable/CasesTable';
import { BrokerDetailGenericSection } from '../../../components/BrokerDetailGenericSection';
import { useCompanyContext } from '../../../../../contexts/company';
import { useBdmAssignedName } from '../../../hooks/useBdmAssignedName';

export const SystemSettingsSectionRefName = 'system-settings-section';

const SystemSettingsContainer = styled.div` ${({ theme }) => `
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: calc(${theme.padding[8]} * 4);
  grid-row-gap: calc(${theme.padding[9]} + ${theme.padding[1]});
  padding: 0 ${theme.padding[10]};
`}`;

export default function SystemSettingsSubSection() {
  const { company } = useCompanyContext();
  const BdmName = useBdmAssignedName(company.bdmAssigned);

  return (
    <BrokerDetailGenericSection
      id={SystemSettingsSectionRefName}
      refName={SystemSettingsSectionRefName}
      title="System settings"
      level={1}
      groupButtons={[<ActionButton onClick={() => { }}><TableIcon className="mi-edit" /></ActionButton>]}
    >
      <SystemSettingsContainer>
        <ModelInput
          label="Search profile"
          field="searchesProfile"
          required
        />

        <TextInput
          label="BDM assigned"
          value={BdmName}
          onChange={() => { }}
          required
          id={company?.bdmAssigned}
        />

        <ModelNewNumericInput
          label="Max broker fee"
          field="commercialDetails.maxBrokerFee"
          required
          prefix="£"
        />

        <ModelInput
          label="Broker code"
          field="brokerCode"
          required
        />
      </SystemSettingsContainer>
    </BrokerDetailGenericSection>
  );
}
